export const saveFilteredDataToLocalStorage =(tableName:any, pagination:any, sorter:any, filters:any) => {
  const filteredData = {
    pagination: pagination,
    sorter: sorter,
    filters: filters
  };
  try {
    const filteredDataJSON = JSON.stringify(filteredData);
    localStorage.setItem(tableName, filteredDataJSON);
  } catch (error) {
    console.error('Error saving filtered data to localStorage:', error);
  }
}

export const getFilteredDataFromLocalStorage =(tableName:any) => {
  try {
    const datosFiltradosJSON = localStorage.getItem(tableName);
    return datosFiltradosJSON ? JSON.parse(datosFiltradosJSON) : null;
  } catch (error) {
    console.error('Error al obtener los datos filtrados del localStorage:', error);
    return null;
  }
}